import React from 'react';
import { Chip } from '@mui/material';
import { CommonBadgeProps } from '../types/common.types';

const STYLE_BY_TYPE: Record<NonNullable<CommonBadgeProps['type']>, { bg: string; color: string; border: string }> = {
  open: { bg: '#f8eef1', color: '#a60f36', border: '#f2c8d6' },
  closed: { bg: '#ebf8ef', color: '#1f7a40', border: '#bfe3cc' },
  pending: { bg: '#fff7e8', color: '#9a5a00', border: '#f3dfb3' },
  'in-progress': { bg: '#edf3ff', color: '#1f56a5', border: '#c6d9ff' },
  rejected: { bg: '#fdeced', color: '#b42318', border: '#f6c9cc' },
  neutral: { bg: '#f4f4f5', color: '#4a4a4a', border: '#e2e2e5' },
};

const CommonBadge: React.FC<CommonBadgeProps> = ({ label, type = 'neutral', size = 'small' }) => {
  const style = STYLE_BY_TYPE[type];

  return (
    <Chip
      label={label}
      size={size}
      sx={{
        backgroundColor: style.bg,
        color: style.color,
        border: `1px solid ${style.border}`,
        fontWeight: 700,
      }}
    />
  );
};

export default CommonBadge;
